import "./loopview.css";
import { useNavigate } from 'react-router-dom'

const LoopFourbody = ({ data, tutorName, subject }) => {
  const navigate = useNavigate()

  const getexpertsbysubject = subject => {
    navigate('/HomeScreen', { state: { selectedSubject: subject } })
  }
  return (
    <div>
      <h5 className="title">
        {/* {data.TitleName.split("\n").map((line, index) => (
          <div key={index} className="title-line">
            {line}
          </div>
        ))} */}
      </h5>

      <p className="bodytext1">
        To further improve your understanding of this topic, book a live 1-on-1
        session with an expert tutor and clarify all your doubts.
      </p>

      {/* <div className="card-footer">
        
        <button className="btn w-100 mt-2 border border-black text-black bg-white ">
          
          Book a 30-minute session
        </button>
      </div> */}

      <div className="card-footer px-2">
  <button className="btn w-100 mt-2 border border-black text-black bg-white flex items-center justify-center gap-2"
  onClick={()=>{
    console.log("subject", subject);
    getexpertsbysubject(subject);
  }}
  >
    
    <img
      className="h-4 w-4"
      src={require("../../Assets/images/white-occ.png")}
      alt="icon"
      style={{ filter: "invert(1)" }} // makes white → black
    />

    Book a 30-minute session
  </button>
</div>

      <hr className="my-4 border-t-2 border-[#BABABA]" />

      <h3 className="titleloop">Also, try asking {tutorName}</h3>

      <p className="bodytext1">
        “What are the different writing styles when it comes to writing for
        social media?”
      </p>
    </div>
  );
};

export default LoopFourbody;
